// 「53吃瓜」网站静态内容数据 —— 简体中文
// 说明：此类网络流行语含义随语境流动，本站内容为互联网圈内通行解读的整理，不涉及虚构认证或资质。

export const brandMeta = {
  name: "53吃瓜",
  slogan: "看懂每一个梗，不掉队",
  email: "hello@53chigua.example",
};

export const navLinks = [
  { id: "intro", label: "它是什么" },
  { id: "meaning", label: "含义拆解" },
  { id: "origin", label: "怎么来的" },
  { id: "usage", label: "怎么用" },
  { id: "glossary", label: "黑话词典" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于本站" },
];

export const meaningSteps = [
  {
    icon: "ri-user-heart-line",
    step: "01",
    title: "吃瓜是底色",
    text: "“吃瓜”源自“吃瓜群众”，指不站队、只看热闹、蹲在评论区围观事件进展的旁观者心态，是一切后续理解的起点。",
  },
  {
    icon: "ri-hashtag",
    step: "02",
    title: "代号与暗号",
    text: "在部分话题与评论区里，“53”被当作一种圈内代称或话题代号使用，用来指代某个持续发酵、值得跟进的热闹事件。",
  },
  {
    icon: "ri-chat-smile-3-line",
    step: "03",
    title: "组合即语境",
    text: "“53吃瓜”组合出现时，通常表示“这个瓜值得蹲、我先搬好板凳”，强调对热门事件的跟进与围观情绪。",
  },
  {
    icon: "ri-refresh-line",
    step: "04",
    title: "含义会流动",
    text: "和多数网络梗一样，它没有唯一标准答案，会随不同社群、不同事件的语境继续演变，关键还是看懂“围观+跟进”的交流信号。",
  },
];

export const originTimeline = [
  {
    tag: "萌芽期",
    time: "评论区",
    title: "从“前排”“蹲”开始",
    text: "在社交平台的热门评论里，网友习惯用“前排”“蹲一个后续”表达想持续围观事件，慢慢形成了看热闹的语言习惯。",
  },
  {
    tag: "扩散期",
    time: "短视频",
    title: "进入短视频与弹幕",
    text: "短视频解说和弹幕文化把这种围观心态进一步放大，相关代号、话题名开始在吃瓜博主与评论区高频出现。",
  },
  {
    tag: "成型期",
    time: "社群",
    title: "圈内形成默契",
    text: "在讨论圈里，“53”逐渐有了指代与代号属性，配合“吃瓜”使用，形成了圈内能秒懂、圈外需科普的默契表达。",
  },
  {
    tag: "进行中",
    time: "日常",
    title: "进入日常交流",
    text: "如今它已成为一种轻快的社交打招呼方式：看到热点先问一句“这瓜你吃了吗”，拉近彼此距离。",
  },
];

export const usageScenes = [
  {
    who: "场景一 · 刚看到热点",
    bubbles: ["懂哥，53吃瓜到底啥意思啊？", "简单说就是“这个热闹蹲住了”，先别下结论，看后续。"],
    tag: "求科普",
  },
  {
    who: "场景二 · 群聊里",
    bubbles: ["又出大瓜了，53吃瓜前排围观", "快说快说，我给你递瓜子 🍉"],
    tag: "同频吃瓜",
  },
  {
    who: "场景三 · 站队前先观望",
    bubbles: ["这事别急着站队，53吃瓜慢慢看", "也是，反转常有，先蹲再说。"],
    tag: "理性围观",
  },
  {
    who: "场景四 · 日常寒暄",
    bubbles: ["最近有什么新瓜吗？", "有个53级的，我发你链接一起看～"],
    tag: "轻松社交",
  },
];

export const glossaryTerms = [
  { word: "吃瓜群众", pinyin: "chī guā qún zhòng", text: "网络热词，指围观事件、看热闹但不轻易站队的普通网友，是吃瓜文化的原住民。" },
  { word: "前排吃瓜", pinyin: "qián pái chī guā", text: "比喻第一时间赶到评论最前方，占好“观景位”围观最新进展，抢占第一手信息。" },
  { word: "蹲一个后续", pinyin: "dūn yí gè hòu xù", text: "表示先不评价、耐心等待事件官方或当事人给出更新的说法与证据。" },
  { word: "实锤", pinyin: "shí chuí", text: "指能坐实某个说法的确凿证据，让事情从“疑似”变成“基本确认”。" },
  { word: "反转", pinyin: "fǎn zhuǎn", text: "事件剧情出现与最初舆论相反的发展，提醒围观者先别急着下结论。" },
  { word: "塌房", pinyin: "tā fáng", text: "原指偶像形象崩塌，现泛指所喜欢的人设、品牌或个人因负面事件让人失望。" },
  { word: "洗地", pinyin: "xǐ dì", text: "指替处于舆论风口的人或事开脱、辩解，常带一定批评意味。" },
  { word: "路人缘", pinyin: "lù rén yuán", text: "指一个公众人物在不追星的大众（路人）心中的好感度与接纳程度。" },
];

export const faqs = [
  {
    q: "53吃瓜和普通的“吃瓜”有什么区别？",
    a: "普通“吃瓜”泛指围观各类热门事件；而“53吃瓜”更像一种带代号语感的进阶表达，多用于暗示某个具体、持续发酵的瓜值得跟进，带有“圈内暗号”的属性。两者核心都是围观，只是语气与指向更具体。",
  },
  {
    q: "53这个数字有什么特殊含义吗？",
    a: "并没有公认的官方解释，它更像网友之间形成的代号式默契。在不同社群、不同话题里可能指向不同事件，因此不必死记硬背一个答案，重点在于理解它承担的“话题代号 + 吃瓜信号”功能。",
  },
  {
    q: "在哪里能经常看到“53吃瓜”这个说法？",
    a: "通常出现在社交平台的热门评论区、群聊、弹幕以及吃瓜类博主的内容里，多见于事件讨论刚开始、剧情尚未明朗的阶段，用来表达“先围观、等后续”的态度。",
  },
  {
    q: "说“53吃瓜”是贬义或负面的吗？",
    a: "基本是中性甚至偏轻松的词汇，多带幽默和自嘲色彩。真正被批评的往往不是“围观”本身，而是造谣、网暴等越界行为。理性吃瓜、不信谣不传谣才是正确姿势。",
  },
  {
    q: "怎么判断一件事值不值得“吃”这个瓜？",
    a: "可以先看信息是否来自可信来源、当事人有无正式回应、有无实锤证据。判断标准是：来源可靠、事实清晰、情绪不绑架。这样既能看懂热闹，也不会被带偏节奏。",
  },
  {
    q: "学会这些黑话对我有什么实际用处？",
    a: "最主要的作用是社交不掉队：看得懂评论区在说什么、接得上朋友的梗、更快判断舆论走向。它本质上是一套互联网圈内的“方言”，懂了才能更好地参与讨论。",
  },
];

export const stats = [
  { num: "1000+", label: "条梗词条目整理" },
  { num: "36", label: "个内容板块" },
  { num: "9成", label: "网友反馈“看懂评论区”" },
  { num: "24h", label: "滚动更新热梗解读" },
];